// Heap ID's
export const LISTING_HEAP_IDS = {
    TICKET_READ_MORE_CLICK: 'ListingWeb - Read more Tickets - Click',
    TICKET_READ_MORE_VIEW: 'ListingWeb - Read more Tickets - View',
};
